// extracted by mini-css-extract-plugin
export default {"imgFooter":"Footer_imgFooter__pTmhr","shakeAnimation":"Footer_shakeAnimation__GArQq","containerFooter":"Footer_containerFooter__cpg6+","box":"Footer_box__JxC0B"};